import { BONUS_COVERS } from './assets'

export type Bonus = {
  number: string
  title: string
  body: string
  /** Mockup del bonus. null = card de portada diseñada en la landing. */
  cover: string | null
  meta: string
}

/**
 * Los 5 bonus reales del pack (ficha DPS 39 · The No-Prep Chess Club Megapack).
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Coach’s Rules & Questions Cheat-Sheet',
    body: 'Settle any rule dispute on the spot — castling, en passant, touch-move, stalemate, clocks — plus the answers to the 30 questions kids actually ask and a quick “is it legal?” tree. Nobody catches you out.',
    cover: BONUS_COVERS['01'],
    meta: 'Printable · 7 pages',
  },
  {
    number: '02',
    title: 'The No-Equipment Club Kit',
    body: 'Print and play: a table-size board, two-color cut-out pieces and a beginner coordinate mat — so you can run any session from day one, even if the club is short on sets.',
    cover: BONUS_COVERS['02'],
    meta: 'Printable · 10 pages',
  },
  {
    number: '03',
    title: 'The Parent Take-Home Pack',
    body: 'A ready-to-hand-out “What we played in club” page, a weekly home challenge and a one-page guide for parents who don’t play — so kids keep playing between meetings.',
    cover: BONUS_COVERS['03'],
    meta: 'Printable · 6 pages',
  },
  {
    number: '04',
    title: 'The Lesson-in-a-Pinch Cards',
    body: '10 zero-prep mini-activities under 5 minutes for when the session ends early or a kid finishes first — sorted by situation, without touching your plan.',
    cover: BONUS_COVERS['04'],
    meta: 'Printable · 7 pages',
  },
  {
    number: '05',
    title: 'The “Start Here” Club Launch Map',
    body: 'One page that tells you exactly which sessions to run in your first four weeks — three paths for total beginners, mixed groups or kids who already play. Teach your first session without thinking.',
    cover: BONUS_COVERS['05'],
    meta: 'Printable · 4 pages',
  },
]
